module.exports = __webpack_public_path__ + "static/img/home-item3.b3b4956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-item3.png
// module id = sflK
// module chunks = 21